import CATEGORY_LISTING_PAGE_CONSTANTS from './CategoryListingPage.constants';

export const getPaginatedProducts = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.FETCH_PAGINATED_PRODUCTS,
  };
};

export const setBucketedPaginatedProducts = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_LOADED_PAGINATED_PRODUCTS,
  };
};

export const getInitialProductsWithFacets = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.FETCH_INITIAL_PRODUCTS_WITH_FACETS,
  };
};

export const getSEOTokenJSON = () => {
  return {
    type: CATEGORY_LISTING_PAGE_CONSTANTS.GET_SEO_TOKEN_JSON,
  };
};

export const setSEOTokenJSON = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_PLP_SEO_TOKEN_LIST,
  };
};

export const setFromHplp = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_FROM_HPLP,
  };
};

export const setHorizontalPlpFlag = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_HORIZONTAL_PLP_FLAG,
  };
};

export const setAlternatePlpFlag = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_ALTERNATE_PLP_FLAG,
  };
};

export const setPaginatedAlternatePlpFlag = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_PAGINATED_ALTERNATE_PLP_FLAG,
  };
};

export const getCategoryBasedProducts = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.FETCH_INITIAL_CATEGORY,
  };
};

export const setCurrentPageNo = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_CURRENT_PAGE,
  };
};

export const setPaginatedPlpLoading = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_PAGINATED_PLP_LOADING,
  };
};

export const setCurrNavIds = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_CURRENT_NAV_IDS,
  };
};
export const setConsolidatedPlpRes = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_PAGINATED_CONSOLIDATED_RES_DATA,
  };
};

export const setPaginatedPlpData = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_LOADED_PRODUCTS,
  };
};

export const setIsProductLoading = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_PRODUCT_LOADING_FLAG,
  };
};

export const setBopisFilterState = (payload) => {
  return {
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_BOPIS_FILTER_STATE,
    payload,
  };
};

export const resetPaginatedProducts = (payload) => {
  return {
    type: CATEGORY_LISTING_PAGE_CONSTANTS.RESET_PAGINATED_PRODUCTS,
    payload,
  };
};

export const resetSeoHeaderCopyLoadedFlag = () => {
  return {
    type: CATEGORY_LISTING_PAGE_CONSTANTS.RESET_SEO_HEADER_COPY_LOADED_FLAG,
  };
};

export const resetCachedTiming = () => {
  return {
    type: CATEGORY_LISTING_PAGE_CONSTANTS.RESET_CACHED_AT,
  };
};

export const loadCategoryPageSeoData = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.LOAD_CATEGORY_PAGE_SEO_DATA,
  };
};

export const setCategoryPageSeoDetails = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_PAGE_SEO_DATA,
  };
};

export const setServiceErrorFlag = (payload) => {
  return {
    payload,
    type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_SERVICE_ERROR_FLAG,
  };
};

export const updateAppliedFilter = (payload) => ({
  type: CATEGORY_LISTING_PAGE_CONSTANTS.UPDATE_APPLIED_FILTERS,
  payload,
});

export const updateFilterFromURL = (payload) => ({
  type: CATEGORY_LISTING_PAGE_CONSTANTS.UPDATE_FILTERS_FROM_URL,
  payload,
});

export const setStageHoldCategoryFlag = (payload) => ({
  type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_STAGE_HOLD_CATEGORY,
  payload,
});

export const setCategoryModuleFilters = (payload) => ({
  type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_MODULE_FILTERS,
  payload,
});

export const setPriceFilterFlag = (payload) => ({
  type: CATEGORY_LISTING_PAGE_CONSTANTS.SET_PRICE_FILTER_FLAG,
  payload,
});
